<template>
  <div id="rewards">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>GiftPay Balances</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="8">
          <v-card color="blue" dark>
            <v-card-text>
              <v-row align="center">
                <v-col cols="5">
                  <v-card-title class="headline text-start">Sandbox TEST</v-card-title>
                  <v-card-subtitle class="text-start">Current Account Balance</v-card-subtitle>
                </v-col>
                <v-col class="display-2 text-end" cols="7" >${{ (balances.sandbox.Balance/100).toFixed(2) }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="8">
          <v-card color="blue" dark>
            <v-card-text>
              <v-row align="center">
                <v-col cols="5">
                  <v-card-title class="headline text-start">Australia PROD</v-card-title>
                  <v-card-subtitle class="text-start">Current Account Balance</v-card-subtitle>
                </v-col>
                <v-col class="display-2 text-end" cols="7" >${{ (balances.au.Balance/100).toFixed(2) }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="8">
          <v-card color="blue" dark>
            <v-card-text>
              <v-row align="center">
                <v-col cols="5">
                  <v-card-title class="headline text-start">New Zealand PROD</v-card-title>
                  <v-card-subtitle class="text-start">Current Account Balance</v-card-subtitle>
                </v-col>
                <v-col class="display-2 text-end" cols="7" >${{ (balances.nz.Balance/100).toFixed(2) }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="8">
          <v-card color="blue" dark>
            <v-card-text>
              <v-row align="center">
                <v-col cols="5">
                  <v-card-title class="headline text-start">United Kingdom PROD</v-card-title>
                  <v-card-subtitle class="text-start">Current Account Balance</v-card-subtitle>
                </v-col>
                <v-col class="display-2 text-end" cols="7" >${{ (balances.uk.Balance/100).toFixed(2) }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="8">
          <v-card color="blue" dark>
            <v-card-text>
              <v-row align="center">
                <v-col cols="5">
                  <v-card-title class="headline text-start">United States PROD</v-card-title>
                  <v-card-subtitle class="text-start">Current Account Balance</v-card-subtitle>
                </v-col>
                <v-col class="display-2 text-end" cols="7" >${{ (balances.us.Balance/100).toFixed(2) }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Rewards",
  data() {
    return {
      balances: {}
    };
  },
  mounted() {
    this.getBalance();
  },
  computed: {},
  methods: {
    getBalance() {
      this.$store.dispatch("retrieveGiftPayBalance").then(() => {
        this.balances = this.$store.getters.giftPayBalance;
      });
    },
  }
};
</script>

<style scoped>
.container.fill-height > .row {
  max-width: initial;
}
</style>